module.exports = __webpack_public_path__ + "static/img/top-badge.146b61f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/top-badge.png
// module id = xblf
// module chunks = 1